import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBJGlOpiPSYXAbRpdtlnORArw43wkfkpNE",
  authDomain: "iwtb-5f2d9.firebaseapp.com",
  projectId: "iwtb-5f2d9",
  storageBucket: "iwtb-5f2d9.firebasestorage.app",
  messagingSenderId: "853908994539",
  appId: "1:853908994539:web:9818d03181857af4d0c1ae",
  measurementId: "G-9GCDZMTK0P"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);